import { IAction } from 'legacy/lut/classes/models/onboarding/IAction'
import { EActionStatus } from 'legacy/lut/classes/models/onboarding/Onboarding'
import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import WebSocketStore from 'core/classes/services/WebSocketStore'
import { IValidationParamsErrorPayload } from 'onboarding/types/request'

export type TAdditionalData = {
  requestId?: number
  actionId?: number
  actionStatus?: EActionStatus
}

export type TExecuteTransitionByTokenResult = {
  success: boolean
  message: string
  additionalData?: TAdditionalData
}

class OnboardingTransitionApi {
  public async executeTransitionByToken() {
    const wsClient = WebSocketStore.get('onboarding')

    return wsClient.call<ExecuteTransitionByTokenResponse>({
      service: 'transition',
      action: 'executeByToken',
      payload: {},
      returnError: true,
    })
  }

  public async executeAplTransition<T>({
    requestId,
    actionId,
    transitionId,
    onboardingRequestData,
    modifiedFields,
  }: IExecuteAPLTransition<T>) {
    const wsClient = WebSocketStore.get('onboarding')
    try {
      const [token] = getTokens(appGetState().app.ownerId)
      const res = await wsClient.call<
        | {
            onboardingRequestData: T
            action: IAction
            error?: IValidationParamsErrorPayload[]
          }
        | { completedAPLRegistrationRequestId: number }
      >({
        service: 'action',
        action: 'execute-apl-transition',
        payload: {
          requestId,
          actionId,
          transitionId,
          modifiedFields,
          onboardingRequestData: onboardingRequestData
            ? JSON.stringify(onboardingRequestData)
            : undefined,
        },
        token: token || undefined,
        withoutTokenRefresh: true,
        isAuth: true,
        returnError: true,
      })

      if ('completedAPLRegistrationRequestId' in res.data) {
        return {
          success: true,
          ...res.data,
        }
      }

      if (res.status === 'fail') {
        return {
          success: false,
          errors: res.data.error,
        }
      }

      return {
        success: res.status === 'success',
        message: res.message || '',
        editableRequestData: res.data.onboardingRequestData,
        action: res.data.action,
      }
    } catch (e: any) {
      return { success: false, errors: e.message, editableRequestData: null, action: null }
    }
  }
}

export const onboardingTransitionApi = new OnboardingTransitionApi()

type ExecuteTransitionByTokenResponse = {
  message: string
  additionalData: {
    requestId: number
    actionId: number
    actionStatus: EActionStatus
  }
}

export interface IExecuteAPLTransition<T> {
  requestId: number
  actionId: number
  transitionId: number
  onboardingRequestData?: T
  modifiedFields: string[]
}
